
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|6275|8881|9627)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
